import http from '../helpers/http';

const PayrollAccountingCodes = (token: string) => {
  const headers = {
    'x-access-token': token,
  };

  return {
    list: async (franchiseeId?: string) => {
      const params = franchiseeId ? { franchiseeId } : {};
      const result = await http.get('/payroll-accounting-codes', {
        headers,
        params,
      });
      return result.data;
    },
    create: async (body: { franchiseeId: string; name: string }) => {
      const result = await http.post('/payroll-accounting-codes', body, { headers });
      return result.data;
    },
    delete: async (id: string) => {
      const result = await http.delete(`/payroll-accounting-codes/${id}`, {
        headers,
      });
      return result.data;
    },
  };
};

export default PayrollAccountingCodes;
